import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { BreadcrumbService } from './layout/service/app.breadcrumb.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { AuthService } from './core/services/auth.service';
import { Router } from '@angular/router';
import { LayoutService } from './layout/service/app.layout.service';

@Component({
  selector: 'app-topbar-old',
  templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnDestroy, OnInit{
    public loggedInUser: string;
    subscription: Subscription;

    items: MenuItem[];

    constructor(
        public breadcrumbService: BreadcrumbService,
        public app: AppMainComponent,
        private _authService: AuthService,
        private _router: Router,
        private _layoutService: LayoutService
        ) {
        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
        });
        
    }

    ngOnInit(): void {
        this._authService.getUser().subscribe(user => {
            this.loggedInUser = user.firstName + ' ' + user.lastName;
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    logout(){
        this._authService.removeToken();
        this._router.navigate(['/login']);
      }

    // primeNg 17
    onMenuButtonClick() {
        this._layoutService.onMenuToggle();
    }

    onRightMenuClick() {
        this._layoutService.showRightMenu();
    }
}
